import React from 'react';
import './PricingCard.css';

// This is the inner component for each individual pricing plan.
const Plan = ({
  title,
  titleDetail,
  description,
  price,
  pricePeriod,
  priceDetails,
  priceDescription,
  buttonText,
  buttonType = 'outline',
  features,
  platformOffer,
  customContent = false,
}) => {
  return (
    <div className="plan-card">
      <div className="card-top">
        <h3>
          {title}
          {titleDetail && <span>{titleDetail}</span>}
        </h3>
        <p className="card-description">{description}</p>
      </div>
      <div className="card-middle">
        {customContent ? (
          <div className="custom-pricing">
            <p>Custom pricing for millions of MAU</p>
          </div>
        ) : (
          <>
            <div className="price-container">
              <div className="price">{price}</div>
              {pricePeriod && <span className="price-period">{pricePeriod}</span>}
            </div>
            {priceDetails && <div className="price-details">{priceDetails}</div>}
            {priceDescription && <div className="price-description">{priceDescription}</div>}
          </>
        )}
      </div>
      <a href="#" className={`btn ${buttonType}`}>
        {buttonText}
      </a>
      <div className="card-copy">
        <ul>
          {features.map((feature, index) => (
            // Using dangerouslySetInnerHTML to render potential HTML like <br> in features
            <li key={index} dangerouslySetInnerHTML={{ __html: feature }} />
          ))}
        </ul>
      </div>
      {platformOffer && (
        <div className="platform-offer">
          <div className="offer-header">PLATFORM OFFER</div>
          <div className="offer-value">$122/month value</div>
          <div className="offer-included">Included for free</div>
          <div className="offer-details">
            <p>
              <strong>Business messaging</strong>
              <br />
              30K free in-app messages
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

// This is the main component you will export and use.
const PricingCard = () => {
  return (
    <div className="pricing-wrapper">
      <div className="pricing-container">
        <div className="pricing-grid-title">
          <h4>Try any chat feature with our free trial</h4>
        </div>
        <div className="pricing-grid">
          <Plan
            title="Free trial"
            description="Experiment with chat"
            price="Free"
            priceDescription="No overages allowed"
            buttonText="Start free trial"
            features={['All pro features', 'No credit card required', 'Community support']}
          />
          <Plan
            title="Starter"
            titleDetail="5K"
            description="Get started with chat"
            price="$349"
            pricePeriod="/month"
            priceDetails="Billed annually, or $399/month billed monthly"
            priceDescription="Overages may apply"
            buttonText="Start free trial"
            features={['Messaging essentials', 'Basic moderation', 'Ticketed support']}
            platformOffer={true}
          />
          <Plan
            title="Pro"
            titleDetail="5K"
            description="Grow your business"
            price="$499"
            pricePeriod="/month"
            priceDetails="Billed annually, or $599/month billed monthly"
            priceDescription="Overages may apply"
            buttonText="Start free trial"
            features={['All Starter features', 'Translation<br/>', 'Data export', 'Image moderation', 'Supergroup channel']}
            platformOffer={true}
          />
          <Plan
            title="Enterprise"
            description="Full powered platform"
            buttonText="Contact sales"
            buttonType="solid"
            features={['All Pro features', 'Dedicated servers', 'Priority support', 'Advanced moderation']}
            platformOffer={true}
            customContent={true}
          />
        </div>
      </div>
    </div>
  );
};

export default PricingCard;